import { post, remove } from '@/api/base'

const sensorsApi = {
  assign: async (containerUuid, sensorUuid) => {
    return await post({
      path: `containers/${containerUuid}/sensors/${sensorUuid}`,
    })
  },
  delete: async (containerUuid, sensorUuid) => {
    return await remove({
      path: `containers/${containerUuid}/sensors/${sensorUuid}`,
    })
  },
}

export default sensorsApi
